module.exports = __webpack_public_path__ + "static/img/39.2b2d749e.jpg";